<div class="mb-3" [class.invalid-feedback]="showError">
  @if (props.label && props.hideLabel !== true) {
    <label [attr.for]="id" class="label">
      {{ props.label }}:
      @if (props.required && props.hideRequiredMarker !== true) {
        <span>*</span>
      }
    </label>
  }
  <div>
    <div style="display: flex;  flex-wrap: wrap;">
      @for (option of $any(props.options); track option.value; let i = $index) {
        <div>
          <nb-checkbox [id]="id + '_' + i"
                       [checked]="isChecked(option)"
                       [formlyAttributes]="field" (checkedChange)="onChange(option.value, $event)">
            {{ option.label }}  ({{ (option.count > 0) ? option.count : 0 }})
          </nb-checkbox>
        </div>
      }
    </div>
  </div>
  @if (showError) {
    <div class="invalid-feedback">
      <formly-validation-message [field]="field"></formly-validation-message>
    </div>
  }
  @if (props.description) {
    <small class="form-text text-muted">{{ props.description }}</small>
  }
</div>
